import styled from 'styled-components';

export const ImageSlide = styled.div`
  width: 100%;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    padding-bottom: 56.25%;
  }
  
  .slide-bg {
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  
  .video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/hero-carousel/styles/staticImageSlide.style.js